<template>
  <div :class="$style.representation">
    <v-container>
      <h1>
        برای شروع همکاری اخذ نمایندگی لطفاً فرم زیر را بصورت کامل پر کنید تا
        کارشناسان ما در اولین فرصت با شما تماس بگیرند.
      </h1>
      <v-row>
        <v-col cols="12" lg="12" md="12">
          <div :class="$style.fieldProfile">
            <label> <span>*</span>نام و نام خانوادگی :</label>
            <v-text-field
                dir="ltr"
                solo
                hide-details
                v-model="vendor_owner"
                placeholder="نام و نام خانوادگی"
            ></v-text-field>
          </div>
        </v-col>
        <v-col cols="12" lg="12" md="12">
          <div :class="$style.fieldProfile">
            <label> <span>*</span>تاریخ تولد :</label>
            <v-text-field
                dir="rtl"
                solo
                hide-details
                v-model="vendor_owner_birth"
            ></v-text-field>
          </div>
        </v-col>
        <v-col cols="12" lg="12" md="12">
          <div :class="$style.fieldProfile">
            <label> <span>*</span>وضعیت تاهل :</label>
            <v-radio-group v-model="vendor_owner_marriage" :class="$style.choose_item">
              <v-radio label=" متاهل " color="#007bff" value="متاهل"></v-radio>
              <v-radio label=" مجرد " color="#007bff" value="مجرد"></v-radio>
            </v-radio-group>
          </div>
        </v-col>
        <v-col cols="12" lg="12" md="12">
          <div :class="$style.fieldProfile">
            <label> <span>*</span>تلفن ثابت :</label>
            <v-text-field
                dir="ltr"
                solo
                hide-details
                placeholder="تلفن ثابت"
                v-model="vendor_tel"
            ></v-text-field>
          </div>
        </v-col>
        <v-col cols="12" lg="12" md="12">
          <div :class="$style.fieldProfile">
            <label> <span>*</span>موبایل :</label>
            <v-text-field
                dir="ltr"
                solo
                hide-details
                v-model="vendor_owner_phone"
                placeholder="موبایل"
            ></v-text-field>
          </div>
        </v-col>
        <v-col cols="12" lg="12" md="12">
          <div :class="$style.fieldProfile">
            <label> <span>*</span>ایمیل :</label>
            <v-text-field
                dir="ltr"
                solo
                hide-details
                placeholder="ایمیل"
                v-model="vendor_owner_email"
            ></v-text-field>
          </div>
        </v-col>
        <v-col cols="12" lg="12" md="12">
          <div :class="$style.fieldProfile">
            <label> استان :</label>
            <v-text-field
                dir="ltr"
                solo
                hide-details
                v-model="vendor_district"
                placeholder="استان"
            ></v-text-field>
          </div>
        </v-col>
        <v-col cols="12" lg="12" md="12">
          <div :class="$style.fieldProfile">
            <label>شهر :</label>
            <v-text-field
                dir="ltr"
                solo
                hide-details
                placeholder="شهر"
                v-model="vendor_city"
            ></v-text-field>
          </div>
        </v-col>
        <v-col cols="12" lg="12" md="12">
          <div :class="$style.fieldProfile">
            <label>وضعیت تملک فروشگاه :</label>
            <v-radio-group v-model="vendor_type" :class="$style.choose_item">
              <v-radio label="مالکیت" color="#007bff" value="مالکیت"></v-radio>
              <v-radio label="استیجاری" color="#007bff" value="استیجاری"></v-radio>
              <v-radio label="ندارم" color="#007bff" value="ندارم"></v-radio>
            </v-radio-group>
          </div>
        </v-col>
        <v-col cols="12" lg="12" md="12">
          <div :class="$style.fieldProfile">
            <label>آدرس :</label>
            <v-textarea
                dir="ltr"
                name="input-7-4"
                hide-details
                solo
                placeholder="آدرس"
                v-model="vendor_owner_address"
            ></v-textarea>
          </div>
        </v-col>
        <v-col cols="12" lg="12" md="12">
          <div :class="$style.fieldProfile">
            <label>نشانی فروشگاه مورد نظر :</label>
            <v-textarea
                dir="ltr"
                name="input-7-4"
                hide-details
                solo
                v-model="vendor_address"
                placeholder="نشانی فروشگاه مورد نظر"
            ></v-textarea>
          </div>
        </v-col>
        <v-col cols="12" lg="12" md="12">
          <div :class="$style.fieldProfile">
            <label>سوابق کاری و شغل فعلی :</label>
            <v-textarea
                dir="ltr"
                name="input-7-4"
                hide-details
                solo
                v-model="vendor_experience"
                placeholder="سوابق کاری و شغل فعلی"
            ></v-textarea>
          </div>
        </v-col>
        <v-col cols="12" lg="12" md="12">
          <div :class="$style.fieldProfile">
            <label>مبلغ اجاره فروشگاه :</label>
            <v-text-field
                dir="ltr"
                solo
                hide-details
                placeholder="مبلغ اجاره فروشگاه"
                v-model="vendor_rent"
            ></v-text-field>
          </div>
        </v-col>
        <v-col cols="12" lg="12" md="12">
          <div :class="$style.fieldProfile">
            <label>متراژ فروشگاه (حداقل 70 متر مربع) :</label>
            <v-text-field
                dir="ltr"
                solo
                hide-details
                v-model="vendor_size"
                placeholder="متراژ فروشگاه"
            ></v-text-field>
          </div>
        </v-col>
        <v-col cols="12" lg="12" md="12">
          <div :class="$style.fieldProfile">
            <label>نحوه آشنایی با کلانا :</label>
            <v-text-field
                dir="ltr"
                solo
                hide-details
                v-model="vendor_refer"
                placeholder="نحوه آشنایی با کلانا"
            ></v-text-field>
          </div>
        </v-col>
        <v-col cols="3" lg="3" md="12">
          <v-btn color="#7ec352" :class="$style.btn_submit" role="button" v-ripple @click="SetRep()">
            ارسال فرم
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import oracle from "@/utils/oracle";

export default {
  name: "Representation",
  data() {
    return {
      vendor_owner: null,
      vendor_owner_phone: null,
      vendor_owner_birth: null,
      vendor_owner_marriage: null,
      vendor_owner_email: null,
      vendor_owner_address: null,
      vendor_district: null,
      vendor_city: null,
      vendor_address: null,
      vendor_size: null,
      vendor_refer: null,
      vendor_experience: null,
      vendor_rent: null,
      vendor_tel: null,
      vendor_type: null,
      requesting: false
    };
  },
  methods: {
    SetRep() {
      if (this.requesting) return;
      if (this.vendor_tel == null || this.vendor_owner == null || this.vendor_owner_phone == null ||
          this.vendor_tel == "" || this.vendor_owner == "" || this.vendor_owner_phone == "") {
        oracle.showMessage('لطفا موارد نام و نام خانوادگی، شماره تلفن و شماره موبایل را حتما وارد نمائید')
        return
      }
      this.requesting = true
      oracle.axios("vendor/create",
          {
            vendor_owner: this.vendor_owner,
            vendor_owner_phone: this.vendor_owner_phone,
            vendor_owner_birth: this.vendor_owner_birth,
            vendor_owner_marriage: this.vendor_owner_marriage,
            vendor_owner_email: this.vendor_owner_email,
            vendor_owner_address: this.vendor_owner_address,
            vendor_district: this.vendor_district,
            vendor_city: this.vendor_city,
            vendor_address: this.vendor_address,
            vendor_size: this.vendor_size,
            vendor_refer: this.vendor_refer,
            vendor_experience: this.vendor_experience,
            vendor_rent: this.vendor_rent,
            vendor_tel: this.vendor_tel,
            vendor_type: this.vendor_type,
          },
          (res) => {
            this.vendor_owner = null
            this.vendor_owner_phone = null
            this.vendor_owner_birth = null
            this.vendor_owner_marriage = null
            this.vendor_owner_email = null
            this.vendor_owner_address = null
            this.vendor_district = null
            this.vendor_city = null
            this.vendor_address = null
            this.vendor_size = null
            this.vendor_refer = null
            this.vendor_experience = null
            this.vendor_rent = null
            this.vendor_tel = null
            this.vendor_type = null
            this.requesting = false
            oracle.showMessage('فرم پذیرش با موفقیت ثبت شد.\n لطفا منتظر تماس از سمت تیم پشتیبانی باشید!', null, null, true)
          }, () => {
            this.requesting = false
          }
      );
    },
  },
  mounted() {
  }
};
</script>
<style module>
.swal2-title {
  font-size: 19px;
}

.representation {
  background: #eeeeee;
}

.representation h1 {
  font-size: 14px;
  color: #333;
  margin: 30px 15px;
  font-weight: 100;
}

.fieldProfile,
.fieldArea {
  margin: 0 15px !important;
  color: #acaca8;
}

.fieldProfile span {
  color: red;
  font-size: 15px;
  padding: 2px;
}

.fieldProfile label {
  color: #333 !important;
  font-size: 12px;
  padding: 10px 0;
}

.fieldProfile {
  font-size: 12px;
  padding: 5px 0;
}

.fieldProfile .v-textarea textarea {
  padding: 5px 10px;
  font-size: 14px;
  font-weight: bold;
}

.fieldProfile .v-text-field input,
.fieldProfile .vpd-input-group input,
.fieldProfile .v-textarea textarea {
  font-size: 11px;
  font-weight: 100;
  text-align: end;
}

.fieldProfile
.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
> .v-input__control
> .v-input__slot {
  box-shadow: none !important;
}

.fieldProfile .v-text-field.v-text-field--solo .v-input__control {
  min-height: 40px !important;
  margin: 8px 0;
}

.fieldProfile .v-input--radio-group--column .v-input--radio-group__input {
  display: flex;
  flex-direction: row !important;
}

.fieldProfile
.v-input--radio-group--column
.v-radio:not(:last-child):not(:only-child) {
  margin: 0;
}

.choose_item .v-radio {
  margin: -18px 15px !important;
}

.btn_submit {
  color: #fff !important;
  height: 40px !important;
  padding: 0 20px !important;
  border-radius: 3px !important;
  margin: 20px 15px !important;
}
</style>
